import { MaterialIcon } from '@common/ui/MaterialIcon';
import { AnalyticsEvents } from '@common/utils/analytics/events';
import { Stack, Button } from '@mui/material';

const connectionMethodIcons: Record<string, string> = {
  cli: 'terminal',
  link: 'open_in_new',
  instructions: 'list_alt',
  json: 'key',
};

const connectionMethodLabels: Record<string, string> = {
  cli: 'CLI',
  link: 'Link',
  instructions: 'Instructions',
  json: 'Parameters',
};

const connectionMethodEvents: Record<string, AnalyticsEvents> = {
  cli: AnalyticsEvents.SessionCliInitiated,
  link: AnalyticsEvents.SessionLinkInitiated,
  instructions: AnalyticsEvents.SessionInstructionsInitiated,
  json: AnalyticsEvents.SessionParametersInitiated,
};

export default function AccessSessionConnectionMethods({
  methods,
  onClick,
}: {
  methods: string[];
  onClick: (method: string) => void;
}) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
      {methods.map((method) => (
        <Button
          key={method}
          onClick={() => onClick(method)}
          startIcon={<MaterialIcon symbol={connectionMethodIcons[method]} />}
          data-trigger={connectionMethodEvents[method]}
        >
          {connectionMethodLabels[method]}
        </Button>
      ))}
    </Stack>
  );
}
